/* ══════════ Ladezustand einer Aktion ══════════
   Für Knöpfe – Anmelden, Speichern, Löschen, Hochladen.

   Was hier NICHT passieren soll: den Knopf durch ein Skeleton ersetzen oder
   die ganze Seite blockieren. Eine laufende Aktion ist ein Zustand DES
   KNOPFES, nicht der Seite.

   Zwei Dinge waren vorher kaputt:

   1. Der Text wurde ausgetauscht („Anmelden" → „Einen Moment …"). Das ist
      doppelt so breit, der Knopf wächst, und alles darunter rutscht. Deshalb
      frieren wir die Breite ein, bevor wir etwas ändern.

   2. Der Text war weg. Wer nach dem Klick nicht mehr liest, was er angestoßen
      hat, verliert den Faden. Jetzt bleibt die Beschriftung stehen und
      bekommt links einen kleinen Kreisel.

   Doppel-Submits fängt `disabled` ab – und zwar zuverlässiger als ein
   Modul-Flag, weil es auch die Tastatur (Enter) und Doppelklicks erfasst. */

export function setzeBeschaeftigt(btn, an) {
  if (!btn) return;
  if (an) {
    if (btn.dataset.busy === '1') return;
    // Breite VOR der Änderung messen, sonst misst man schon den neuen Inhalt.
    const breite = btn.getBoundingClientRect().width;
    if (breite) btn.style.minWidth = Math.ceil(breite) + 'px';
    btn.dataset.busy = '1';
    btn.dataset.busyHtml = btn.innerHTML;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.innerHTML = '<span class="btn-spin" aria-hidden="true"></span>' + btn.dataset.busyHtml;
    return;
  }
  if (btn.dataset.busy !== '1') return;
  btn.innerHTML = btn.dataset.busyHtml || btn.innerHTML;
  delete btn.dataset.busy;
  delete btn.dataset.busyHtml;
  btn.disabled = false;
  btn.removeAttribute('aria-busy');
  btn.style.minWidth = '';
}

/* Eine Aktion mit Knopf-Ladezustand ausführen.

   Gibt zurück, was `fn` zurückgibt; Fehler wandern nach oben, damit die
   aufrufende Stelle sie dort anzeigen kann, wo sie hingehören (Formular-
   Status, Toast, Zeile). Der Knopf wird in JEDEM Fall wieder freigegeben. */
export async function mitLadezustand(btn, fn) {
  setzeBeschaeftigt(btn, true);
  try { return await fn(); }
  finally { setzeBeschaeftigt(btn, false); }
}
